export default __webpack_public_path__ + "static/longhash@2x-df2a108489bfbefe6a5d3619cea77dcd.png";